module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "admin-tab"
  }, [_c('wb-datatable', _vm._b({
    staticClass: "apps-table",
    attrs: {
      "searchKey": 'Name'
    },
    on: {
      "addEmit": _vm.openDialog,
      "editEmit": _vm.openDialog,
      "deleteEmit": _vm.openConfirmDialog
    }
  }, 'wb-datatable', _vm.tableAppProps, false)), _vm._v(" "), _c('md-dialog', {
    ref: "dialog"
  }, [_c('md-dialog-title', [_vm._v(_vm._s(_vm.isNew ? 'Create app group' : 'Update app group'))]), _vm._v(" "), _c('md-dialog-content', [(_vm.appGroup) ? _c('form', [_c('md-input-container', [_c('label', [_vm._v("Name")]), _vm._v(" "), _c('md-input', {
    model: {
      value: (_vm.appGroup.Name),
      callback: function($$v) {
        _vm.$set(_vm.appGroup, "Name", $$v)
      },
      expression: "appGroup.Name"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Category")]), _vm._v(" "), _c('md-input', {
    model: {
      value: (_vm.appGroup.Category),
      callback: function($$v) {
        _vm.$set(_vm.appGroup, "Category", $$v)
      },
      expression: "appGroup.Category"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Image")]), _vm._v(" "), _c('md-input', {
    model: {
      value: (_vm.appGroup.image),
      callback: function($$v) {
        _vm.$set(_vm.appGroup, "image", $$v)
      },
      expression: "appGroup.image"
    }
  })], 1)], 1) : _vm._e()]), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        return _vm.closeDialog(false)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        return _vm.closeDialog(true)
      }
    }
  }, [_vm._v(_vm._s(_vm.isNew ? 'Create' : 'Update'))])], 1)], 1), _vm._v(" "), _c('md-dialog', {
    ref: "confirmDialog"
  }, [_c('md-dialog-title', [_vm._v("Are you sure you would like to remove this app group?")]), _vm._v(" "), _c('md-dialog-content', [_vm._v("\n            App group will permanently be removed from the database. "), _c('br')]), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        return _vm.closeConfirmDialog(false)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        return _vm.closeConfirmDialog(true)
      }
    }
  }, [_vm._v("Delete")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e7b90462!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AdminTabs/AdminAppGroups.vue
// module id = 319
// module chunks = 2